import moment from "moment";
import { WebChatState } from "../WebChatContext";

export function druidLanguageComparison(firstLocale: string, secondLocale: string) {
    return firstLocale.toLocaleLowerCase().startsWith(secondLocale.toLocaleLowerCase()) ||  secondLocale.toLocaleLowerCase().startsWith(firstLocale.toLocaleLowerCase());
}

export function isNewActivity(currentState: WebChatState, activity: any): boolean {
    return (currentState.directlineInstance?.serverTimestamp || moment()) < moment(activity.timestamp);
}